var exports = {
  "i1": "InterfaceTab.module__previewContainer___NVRQOC",
  "gp": "InterfaceTab.module__previewContent___NVRQOC",
  "rv": "InterfaceTab.module__tooltipContent___NVRQOC",
  "zX": "InterfaceTab.module__typingContainer___NVRQOC",
  "ro": "InterfaceTab.module__typingAnimationWrapper___NVRQOC",
  "OI": "InterfaceTab.module__typingAvatars___NVRQOC",
};

module.exports = exports;
